/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeEmailAddressRequest } from '../../models/change-email-address-request';
import { TwoFaExpiry } from '../../models/two-fa-expiry';

export interface RequestChangeEmailAddress$Params {
      body: ChangeEmailAddressRequest
}

export function requestChangeEmailAddress(http: HttpClient, rootUrl: string, params: RequestChangeEmailAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFaExpiry>> {
  const rb = new RequestBuilder(rootUrl, requestChangeEmailAddress.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TwoFaExpiry>;
    })
  );
}

requestChangeEmailAddress.PATH = '/users/request-change-email-address';
